import { render, staticRenderFns } from "./TxAgents.vue?vue&type=template&id=4a9eca6e"
import script from "./TxAgents.vue?vue&type=script&lang=js"
export * from "./TxAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports